var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LeftSidebar',{attrs:{"visible":_vm.visible,"baseClass":"parvandeh-status-wrapper","title":_vm.title},on:{"close":_vm.close}},[[_c('ParvandehReportsList',{attrs:{"visible":_vm.visible,"code":_vm.code,"saltFileName":_vm.saltFileName}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }